function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Design",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "HOME-07",
  transform: "translate(-20.000000, -907.000000)"
}, React.createElement("g", {
  id: "arrow",
  transform: "translate(22.000000, 909.000000)",
  stroke: "#fff"
}, React.createElement("g", {
  id: "Group-5-Copy"
}, React.createElement("path", {
  d: "M35.2494184,33.2356224 L16.6175816,33.2356224 C7.44033673,33.2356224 -0.000275510204,25.7950102 -0.000275510204,16.6177653 C-0.000275510204,7.43960204 7.44033673,-9.18367347e-05 16.6175816,-9.18367347e-05",
  id: "Stroke-1",
  strokeWidth: 4
}), React.createElement("polyline", {
  id: "Stroke-3",
  strokeWidth: 4,
  points: "23.6083776 44.8766633 35.249602 33.2354388 23.6083776 21.5932959"
})))));

var SvgArrowLink = function SvgArrowLink(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "41px",
    height: "49px",
    viewBox: "0 0 41 49",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgArrowLink, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/arrowLink.cc6c361d.svg";
export { ForwardRef as ReactComponent };